<div class="layout-row align-end gap-2px responsive-column container m-b-20">
  <button mat-raised-button color="primary" [routerLink]="['edit']" *LOSxHasPermission="'UPDATE_FUND'">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>
</div>

<div class="container">
  <mat-card>
    <mat-card-content>
      <div class="layout-row-wrap">
        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.name' | translate }}
        </div>

        <div class="flex-50">
          {{ fundData.name }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.External Id' | translate }}
        </div>

        <div class="flex-50">
          <LOSx-external-identifier
            externalId="{{ fundData.externalId }}"
            completed="true"
          ></LOSx-external-identifier>
        </div>
      </div>

      <div class="layout-row layout-align-center gap-2percent column-on-mobile">
        <button type="button" mat-raised-button color="primary" [routerLink]="['../']">
          {{ 'labels.buttons.Back' | translate }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
